import { Drawer } from '@mui/material';
import { FunctionComponent, useEffect, useState } from 'react';

import { Serie } from '../../shared/types/Serie';
import PanelSerie from '../screen/PanelSerie';

interface SerieSheetProps {
  serie: Serie | null;
  onClose: () => void;
}

/**
 * Bottom sheet showing a serie (PanelSerie). Used everywhere a serie can be opened (home, collections...).
 */
const SerieSheet: FunctionComponent<SerieSheetProps> = ({ serie, onClose }) => {
  // Keep the serie displayed while the sheet slides out
  const [displayedSerie, setDisplayedSerie] = useState<Serie | null>(serie);
  useEffect(() => {
    if (serie) setDisplayedSerie(serie);
  }, [serie]);

  return (
    <Drawer
      anchor="bottom"
      open={serie !== null}
      onClose={onClose}
      // The panel opens antd modals (assignation, Edifice): stay below them and let them take the focus
      sx={{ zIndex: 900 }}
      disableEnforceFocus
      SlideProps={{ onExited: () => setDisplayedSerie(null) }}
      PaperProps={{
        'aria-label': displayedSerie?.name ? `Série ${displayedSerie.name}` : 'Série',
        'sx': {
          height: '92vh',
          maxWidth: 1100,
          mx: 'auto',
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          backgroundColor: '#120d35',
          backgroundImage: 'none',
          color: 'white',
          overflowY: 'auto',
        },
      }}
      slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(8, 5, 26, 0.7)', backdropFilter: 'blur(2px)' } } }}>
      {displayedSerie !== null ? <PanelSerie key={displayedSerie.id} close={onClose} serie={displayedSerie} /> : null}
    </Drawer>
  );
};

export default SerieSheet;
